/**
 * Derive a default username from an email's local part.
 *   xyasserksa@gmail.com -> "xyasserksa"
 *   john.doe@x.com       -> "johndoe"
 *
 * The account service (00acc) only accepts alphanumeric usernames
 * (/^[A-Za-z0-9]*$/), so anything else (dots, plus tags, hyphens) is stripped.
 * Returns "" if the email yields nothing usable, in which case the caller
 * should ask the user to type one.
 */
export function usernameFromEmail(email: string): string {
  if (!email) return '';
  const local = email.split('@')[0] ?? '';
  return local.replace(/[^A-Za-z0-9]/g, '');
}
